<template>
  <div class="page">
    <div class="page_top">
      <div class="sechout">
        <div class="sech-left" @click="back()">
          <van-icon name="arrow-left" color="#ffffff" size="20" />
        </div>
      </div>
      <div class="page_top_title">
        <span class="page_top_title_txt">选择楼号单元</span>
        <img class="page_top_title_img" src="../../../../assets/house/property/2／6.png">
      </div>
      <span class="page_top_tip">完善小区信息后才可使用物业功能</span>
    </div>
    <div class="list">
      <div :class="[id == item.id?'cell_active':'cell']" v-for="(item,index) in unitList" :key="index"
        @click="selUnit(item.id)">
        {{item.name}}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        id: '',
        unitList: [{
          name: '1号楼1单元',
          id: 1
        }, {
          name: '1号楼2单元',
          id: 2
        }, {
          name: '1号楼3单元',
          id: 3
        }, {
          name: '2号楼1单元',
          id: 4
        }, {
          name: '2号楼2单元',
          id: 5
        }, {
          name: '2号楼3单元',
          id: 6
        }, ]
      }
    },
    created() {},
    methods: {
      back() {
        this.$router.go(-1);
      },
      selUnit(id) {
        this.id = id
        this.$router.push('/house/property/binding3')
      }
    },
  }
</script>

<style lang="less" scoped>
  .page_top {
    height: 181px;
    background: url('../../../../assets/house/property/binding_bg.png') no-repeat right top;
  }

  .sechout {
    height: 44px;
    padding: 15px 15px 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .sech-left,
  .sech-right {
    width: 104px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .page_top_title {
    padding-left: 30px;
    padding-right: 20px;
    margin-bottom: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .page_top_title_txt {
    font-size: 24px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 24px;
  }

  .page_top_title_img {
    width: 54px;
  }

  .page_top_tip {
    padding-left: 30px;
    font-size: 14px;
    color: #FFFFFF;
  }

  .list {
    height: 500px;
    padding: 0 16px;
    padding-top: 15px;
    overflow-y: scroll;
  }

  .cell {
    height: 50px;
    margin-bottom: 12px;
    padding-left: 20px;
    font-size: 15px;
    font-weight: 400;
    color: #222325;
    line-height: 21px;
    background-color: #F8F8F8;
    display: flex;
    align-items: center;
  }

  .cell_active {
    height: 48px;
    margin-bottom: 10px;
    padding-left: 19px;
    font-size: 15px;
    font-weight: 400;
    color: #222325;
    line-height: 21px;
    background-color: #F8F8F8;
    display: flex;
    align-items: center;
    border: 1px solid #26C165;
  }
</style>